import {
  themeToTokensObject,
  typographyStyles,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

export const customTheme = {
  ...webDarkTheme,
  ...webLightTheme,

  //Merriweather Sans
  fontFamilyBase: "Merriweather Sans",

  //'Lora', serif
  fontFamilyHeading: "'Lora', serif",

  //new font sizes
  fontSizeBase150: "11px",
  fontSizeBase250: "13px",
  fontSizeBase450: "18px",

  //new line heights
  lineHeightBase450: "24px",
  lineHeightBase500: "28px",

  //UNFCCC colors
  UNFCCCPrimaryOcean90: "#5E5E9B",
  UNFCCCPrimaryOcean100: "#191970",
  UNFCCCPrimaryAccent100: "#00949F",
  UNFCCCPrimaryAccent120: "#007F89",
  UNFCCCBrandGraphLevel1: "#3050C6",
  UNFCCCBrandGraphLevel2: "#A79CF1",
  UNFCCCBrandGraphLevel3: "#C6D2F6",
  UNFCCCBrandGraphLevel4: "#637CEF",
  UNFCCCBrandGraphLevel5: "#ECA5D1",
  UNFCCCBrandGraphLevel6: "#D957A8",
  UNFCCCBrandGraphLevel7: "#00949F",
  UNFCCCBrandGraphLevel8: "#66BFC5",
  UNFCCCBrandGraphLevel9: "#3A96DD",
  UNFCCCBrandGraphLevelTotal: "#BF0077",
  colorNeutralPrimaryGrey4: "#F7F7F8",
  colorsNeutralPrimaryGrey6: "#8E8E8F",
  colorNeutralGrey94: "#F0F0F0",

  //new colors
  fontDarkGrayBody: "#424245",
  fontBlack100: "#1A1A1C",
  globalColorBrand150: "#F0F3FD",
  globalColorBrand160: "#F7F9FE",

  //overridden colors
  colorBrandBackground: "#4169E2",
  colorBrandForeground2: "#2D56D3"
};

export const customTokens = themeToTokensObject(customTheme);

export const customTypographyStyles = {
  ...typographyStyles,
  display: {
    ...typographyStyles.display,
    fontFamily: customTokens.fontFamilyHeading,
  },
  display2: {
    fontFamily: customTokens.fontFamilyHeading,
    lineHeight: customTokens.lineHeightHero900,
    fontWeight: customTokens.fontWeightSemibold,
    fontSize: customTokens.fontSizeHero900,
  },
  bodyLRegular: {
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase450,
    fontWeight: customTokens.fontWeightRegular,
  },
  bodyLMedium: {
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase450,
    fontWeight: customTokens.fontWeightSemibold,
  },
  bodyMRegular: {
    ...typographyStyles.body2,
  },
  bodyXXRegular: {
    fontSize: customTokens.fontSizeBase150,
    lineHeight: customTokens.lineHeightBase300,
    fontWeight: customTokens.fontWeightRegular,
  },
  bodyXSRegular: {
    fontSize: customTokens.fontSizeBase250,
    lineHeight: customTokens.lineHeightBase300,
    fontWeight: customTokens.fontWeightRegular,
  },
  bodyXSSemibold: {
    fontSize: customTokens.fontSizeBase250,
    lineHeight: customTokens.lineHeightBase300,
    fontWeight: customTokens.fontWeightSemibold,
  },
  body3: {
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase500,
    fontWeight: customTokens.fontWeightRegular,
  },
  body3Extension: {
    fontSize: customTokens.fontSizeBase450,
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase500,
  },
  body3StrongExtension: {
    fontSize: customTokens.fontSizeBase450,
    fontWeight: customTokens.fontWeightBold,
    lineHeight: customTokens.lineHeightBase500,
  },
  headingH3Semibold: {
    ...typographyStyles.subtitle1,
    fontFamily: customTokens.fontFamilyHeading,
  },
  headingH4Semibold: {
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase450,
    fontWeight: customTokens.fontWeightSemibold,
    fontFamily: customTokens.fontFamilyHeading,
  },
  headingH2Regular: {
    fontFamily: customTokens.fontFamilyHeading,
    fontSize: customTokens.fontSizeBase600,
    lineHeight: customTokens.lineHeightBase600,
    fontWeight: customTokens.fontWeightRegular,
  },
  headingH4Regular: {
    fontFamily: customTokens.fontFamilyHeading,
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase450,
    fontWeight: customTokens.fontWeightRegular,
  },
  headingH1: {
    ...typographyStyles.title2,
    fontFamily: customTokens.fontFamilyHeading,
  },
  headingH2Semibold: {
    ...typographyStyles.title3,
    fontFamily: customTokens.fontFamilyHeading,
  },
  bodyLSemibold: {
    fontSize: customTokens.fontSizeBase450,
    fontWeight: customTokens.fontWeightBold,
    lineHeight: customTokens.lineHeightBase450,
  },
  bodySSemibold: {
    ...typographyStyles.body1Stronger,
  },
  bodyMSemibold: {
    ...typographyStyles.subtitle2Stronger,
  },
};
